import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import AppTagChipArray from './AppTagChipArray';
import AppTagChipArrayTop from './AppTagChipArrayTop';
import Grid from "@material-ui/core/Grid";
import icons_bn from '../../other/icons_bn.json'

import Chip from '@material-ui/core/Chip';

export default function AppDynCard(props) {
	const classes = useStyles();
	let { data, basket, lang } = props
	const stabilyzeChipArr = ( arr) => {
		let newArr = [];
		arr.map(el => {
			if (!newArr.includes(el)) {
				newArr.push(el)
			}
		})
		let vers = props.data.Progress.split(' ')[1];
		if (!newArr.includes(vers)) {
			newArr.push(vers)
		}
		newArr = newArr.sort();
		//console.log("stabilyzeChipArr", arr, newArr)
		return newArr

	}
	return (
		<Card className={classes.rootWide} >
			<Grid container justify="space-between" className={classes.cntrCardHeader}>
				<Grid item style={{ width: '50%' }}>
					<Typography component='span' style={{ fontSize: '14px' }}> {lang === "Ru" ? 'ЦФТ-Банк' : "CFT Bank"}</Typography>
				</Grid>
				{basket
					?
					<AppTagChipArrayTop lang={lang} DateEndSaleStock={data.DateEndSaleStock} DateStartStock={data.DateStartStock} StockLink={data.StockLink} dataStartSale={props.data.promo} isStandant={props.data.standartpackage} isResearchMarket={props.data.researchmarket} dataEndSale={props.data.dateendsale} position='top' width={'50%'} />
					:
					// <li key={`${data.key}__topChipData`} className={classes.li}>
					<Grid container direction="row"  justify={/*Array.isArray(props.data.additional_versions) && props.data.additional_versions.length > 0  && ( props.data.Progress.slice(0, 5) === 'Новое' || props.data.Progress.slice(0, 3) === 'New')? "space-between" :*/ "flex-end"} alignItems="center" key={`${props.data.key}__topChipData`} className={classes.li}>
							{
								Array.isArray(props.data.additional_versions) && ( props.data.Progress.slice(0, 5) === 'Новое' || props.data.Progress.slice(0, 3) === 'New')
								?
								stabilyzeChipArr(props.data.additional_versions).map((elem, i) => {return (
									<Chip
										style={{ backgroundColor: '#81D39D', marginRight: i !== stabilyzeChipArr(props.data.additional_versions).length -1 ? 8 : undefined }}
										label={`${lang === 'Ru' ? 'Новое' : 'New'} ${elem}`}
										className={classes.chip}
									/>

								)})
								:
								null
							}
								{Array.isArray(props.data.additional_versions) && ( props.data.Progress.slice(0, 5) === 'Новое' || props.data.Progress.slice(0, 3) === 'New')
								
								?
								null
								:
							
								<Chip
									style={{ backgroundColor: props.data.Progress.slice(0, 8) === 'Развитие' || props.data.Progress.slice(0, 11) === 'Development' ? '#8094FF' : props.data.Progress.slice(0, 5) === 'Новое' || props.data.Progress.slice(0, 3) === 'New' ? '#81D39D' : props.data.Progress.slice(0, 5) === 'Анонс' || props.data.Progress.slice(0, 11) === 'Coming soon' ? '#FE9D67' : '' }}
									label={props.data.Progress}
									className={classes.chip}
								/>
								
							}
							
						</Grid>
					// </li>
				}
			</Grid>

			<Grid container alignItems="flex-start" xs={12} className={classes.cntrCardBody}>
				<Grid container xs={4} alignItems="flex-start" className={classes.cntrCardBodyBlock}>
					<StyledCardHeader
						className={classes.header}
						avatar={
							<Avatar aria-label="recipe" className={classes.avatar}
								style={{ backgroundColor: data.COLOR && data.COLOR.length > 5 ? `#${data.COLOR}` : '#E45670' }}
								src={icons_bn[`${props.data.ICON_ID_BN}`]}
							/>
						}
						title={
							<React.Fragment>
								<Grid container direction="row" justify="flex-start" alignItems="center" spacing={3} style={{ marginTop: 0, marginBottom: 8 }}>
									<AppTagChipArray key1={data.CodeAsvul} key2={data.Version} key3={data.DateStartSale} position='middle' />
								</Grid>

								<Typography style={{ fontSize: '12px', lineHeight: '14px', fontWeight: '500', marginBottom: 8 }}>
									{props.data[`BN_Title`]}
								</Typography>
							</React.Fragment>
						}

						subheader={
							<Typography className={classes.subheader}>
								{props.data[`SN_Title`]}
							</Typography>
						}
					/>
				</Grid>

				<Grid container xs={8}>
					<CardContent className={classes.content}>

						<Grid container>
							<a href={`/applications/card/${props.data.CodeAsvul}`} style={{ textDecoration: 'none', maxWidth: '100%' }} rel="noopener noreferrer" target="_blank">
								<Grid container direction="column" justify="flex-start" alignItems="flex-start" style={{ paddingRight: 25 }}>
									<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
										{props.data.Title}
									</Typography>

									<Typography variant="body2" color="textSecondary" component="p" className={classes.contentSubbody}>
									<div dangerouslySetInnerHTML={{ __html: props.data.BriefDescription }}></div>	
									</Typography>

								</Grid>
							</a>

							<Grid xs={6} container direction="row" justify="flex-start" alignItems="flex-start" spacing={3} style={{ margin: 0, padding: '0 25px' }}>
								{/* <Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
										{translate.Words[`Price${lang}`]}{data.paymentcomment}
									</Typography> */}

								{/* <Grid item container direction="row" className={classes.priceContainer} style={{ padding: 0 }}>
										{+props.data.paymentone >= 0 ?
											<Grid item style={{ width: 93, marginRight: 16 }}>
												<CustomTooltip title={lang === 'Ru' ? 'Единовременный лицензионный платеж / Цена покупки' :
													"One-time license payment / Purchase price"}>
													<Typography className={classes.pricePrimary}>{+props.data.paymentone === 0 ? `Не взимается` :  `${parseFloat(data.paymentone).toFixed(3)} ${langYE}` } {data.paymentcommentone}</Typography>
												</CustomTooltip>
												{+props.data.paymentonestock > 0 && +props.data.paymentonestock < 99999
													?
													<CustomTooltip title={lang === 'Ru' ? 'Особые условия лицензирования – см. страницу с описанием Приложения' : "Special license terms – see. Application description page"}>
														<Typography className={classes.priceSecondary}>{parseFloat(props.data.paymentonestock).toFixed(3)} {langYE}</Typography>
													</CustomTooltip>
													:
													''
												}
											</Grid>
											: ""}

										<Grid item>
											<CustomTooltip title={lang === 'Ru' ? 'Ежемесячный лицензионный платеж / Периодическая лицензия' :
												"One-time license payment / Periodic license"}>
												<Typography className={classes.pricePrimary}>{data.paymentmonthly ? `${parseFloat(data.paymentmonthly).toFixed(3)} ${langYE}` : ''}  {data.paymentcommentmonthly}</Typography>
											</CustomTooltip>
											{props.data && props.data.paymentmonthlystock && +props.data.paymentmonthlystock > 99990 ? '' : <Typography className={classes.priceSecondary}>{data.paymentmonthlystock} {langYE}</Typography>}
										</Grid>
									</Grid> */}
							</Grid>
						</Grid>

					</CardContent>
				</Grid>

			</Grid>

			<Grid container xs={12} className={classes.cntrCardFooter}>


			</Grid>
		</Card >
	);
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
	rootWide: {
		// minHeight: 218,
		marginBottom: 16,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		paddingTop: 10,
		// paddingRight: 0,
		// paddingBottom: 24,
		// paddingLeft: 0,
		padding: theme.spacing(3),
		width: '100%',

		'&:hover': {
			boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		}
	},

	avatar: {
		// backgroundColor: iconColor,
		height: 62,
		width: 62,
		borderRadius: 24,
		padding: 15
	},

	icon: {
		marginLeft: 8,
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	content: {
		// height: 289,
		// overflow: 'hidden',
		padding: 0,
		width: '100%',
		'&:last-child': {
			paddingBottom: 12
		}
		// marginTop: 16
	},

	contentBody: {
		fontSize: '14px',
		fontWeight: '500',
		lineHeight: '18px',
		color: '#000'
	},

	contentSubbody: {
		marginTop: theme.spacing(1),
		fontSize: '13px',
		fontWeight: '400',
		lineHeight: '16px',
		color: '#8987A2'
	},

	header: {
		padding: 0,
		title: {
			fontSize: 22
		}
	},

	subheader: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2'
	},

	actions: {
		padding: '0',
		paddingTop: '7',
		width: '100%',
		// position: 'absolute',
		// bottom: 16,
		// right: 24
	},

	pricePrimary: {
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '18px',
		color: '#000'
	},

	priceSecondary: {
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '18px',
		color: '#8987A2'
	},

	cntrCardHeader: {
		// padding: '0 24px 0 24px',
		minHeight: 32,
		marginBottom: 0,
	},

	cntrCardBody: {},

	cntrCardBodyBlock: {
		// padding: '0 24px'
	},

	cntrCardFooter: {
		// padding: '0 24px 0 24px'
	},

	chip: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		backgroundColor: '#BCBBD0',
		fontSize: 13,
		lineHeight: '16px',
		color: '#FFF',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,
		'& > span': {
			padding: 0
		},
	},
}));

const StyledCardHeader = withStyles({
	root: {
		alignItems: 'flex-start',
	},
})(CardHeader);